<div class="modal-header bg-light">
    <h4 class="modal-title strong">Vessel nomination</h4>
    <div *ngIf="vesselNominationStatus == 'ACCEPTED'" class="badge badge-success">Vessel accepted</div>
    <div *ngIf="vesselNominationStatus == 'REJECTED'" class="badge badge-secondary">Vessel rejected</div>
</div>
<div *ngIf="enableLoader" id="loader"></div>
<div class="modal-body" *ngIf="!enableLoader">
    <div>
    <div>
        <p class="mb-0 mt-1">We have nominated the following vessel for your <strong>shipment No. {{shipmentId}}.</strong></p>
        <p>Please review the details below and confirm your acceptance.</p>
    </div>
    <div class="d-flex justify-content-between">
    <div>
        <div class="small text-secondary">Vessel name</div>
        <div class="shipIdLabel">{{vesselData.name}}</div>
    </div>
    <div>
        <div class="small text-secondary">IMO number</div>
        <div class="shipIdLabel">{{getnumber(vesselData.lloydsIdentificationID)}}</div>
    </div>
</div>
    <div class="d-flex mt-3">
        <div class="col pl-0">
            <div class="d-flex justify-content-evenly">
                <p class="text-secondary col-md-9 pl-0">Date Built</p> <p>{{getDate(vesselData.registeredDate) }}</p>
            </div>
            <div class="d-flex justify-content-evenly">
                <p class="text-secondary col-md-9 pl-0">ETA</p> <p>{{getDate(vesselData.actualStartFromDate)}}</p>
            </div>
            <div class="d-flex justify-content-evenly">
                <p class="text-secondary col-md-9 pl-0">GRT</p> <p>{{vesselData.grossTonnageMeasure}}</p>
            </div>
            <div class="d-flex justify-content-evenly">
                <p class="text-secondary col-md-9 pl-0">NRT</p> <p>{{vesselData.netTonnageMeasure}}</p>
            </div>
        </div>
        <div class="col ml-5">
            <div class="d-flex justify-content-evenly">
                <p class="text-secondary col-md-10">Draught (m)</p> <p>{{vesselData.draftMeasure}}</p>
            </div>
            <div class="d-flex justify-content-evenly">
                <p class="text-secondary col-md-10">Breadth (m)</p> <p>{{vesselData.widthMeasure}}</p>
            </div>
            <div class="d-flex justify-content-evenly">
                <p class="text-secondary col-md-10">Length (m)</p> <p>{{vesselData.lengthMeasure}}</p>
            </div>
            <div class="d-flex justify-content-evenly">
                <p class="text-secondary col-md-10">DWT (Summer)</p> <p>{{vesselData.summerDraft}}</p>
            </div>
        </div>
    </div>
    <div>
        {{vesselData.standardText}}
    </div>
	<form [formGroup]="vesselnominationform">
    <div *ngIf="showAcceptRemarks || showRejectRemarks" class="mt-2">
       <p class="bold"> Remarks</p> 
       <input class="form-control w-100 rounded" id="Remarks" formControlName="Remarks" placeholder="Leave your remarks here" (keypress)="remarksfeild($event)">
       <span *ngIf="showErrRemarks" class="validity-error"><i class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>Please leave a comment for the rejection reason.</span>
       <p class="small text-secondary">Specific requests for vessels will be considered but are not guaranteed</p>
    </div>
    <div *ngIf="(vesselNominationStatus == 'ACCEPTED') || (vesselNominationStatus =='REJECTED')" class="mt-2">
       <p class="bold text-secondary"> Remarks</p> 
       <input class="form-control w-100 rounded" id="Remarks" disabled formControlName="Remarks" [(ngModel)]="vesselData.reviewReason" [disabled]="disableRemarks">
    </div>
    </form>
    </div>
  </div>
  <div class="modal-footer bg-light">
    <div class="d-flex flex-column w-100" >
        <div *ngIf="vesselNominationStatus == 'NOMINATED'">
            <button *ngIf="!showAcceptRemarks && !showRejectRemarks" class="btn btn-primary btn-block btn-sm buttonPrimary"  type="submit" (click)="acceptVessel(true)" >Accept vessel</button>
            <button *ngIf="showAcceptRemarks && !showRejectRemarks" class="btn btn-primary btn-block btn-sm buttonPrimary"  type="submit" (click)="confirmVessel('ACCEPTED')" >Confirm vessel</button>
        <div class="d-flex">
            <button *ngIf="showAcceptRemarks || showRejectRemarks" class="btn btn-block btn-sm btn-light w-100 button mt-2 mr-3" type="button" (click)="cancel()">Cancel</button>
            <button *ngIf="!showAcceptRemarks && !showRejectRemarks" class="btn btn-block btn-sm btn-light w-100 button mt-2 mr-3" type="button" (click)="activeModal.dismiss('close click')">Cancel</button>
            <button *ngIf="!showAcceptRemarks" class="btn btn-block btn-sm btn-light w-100 button" type="button" (click)="rejectVessel('REJECTED')">Reject vessel</button>
        </div>
    </div>
        <div *ngIf="(vesselNominationStatus == 'ACCEPTED') || (vesselNominationStatus =='REJECTED')">
            <button class="btn btn-block btn-sm btn-light w-100 button mt-2 mr-3" type="button" (click)="activeModal.dismiss('close click')">Close</button>    
        </div>
  </div>
</div>